import { AxiosRequestConfig } from 'axios';
import {apiAxios} from '../api/axios';

export function fetchUserLogs(params: any) {
    return apiAxios.get('/userLogs', {params} as AxiosRequestConfig);
}